export default "__VITE_ASSET__CbqwV3JH__"